module.exports = __webpack_public_path__ + "img/search.e6901923.svg";